import React from 'react';
import ReactInputMask from 'react-input-mask';

const CPFInput = ({ placeholder, onBlur, onChange, ...props }) => (
  <ReactInputMask
    onBlur={onBlur}
    onChange={onChange}
    type="text"
    placeholder={placeholder || 'Insira seu CEP'}
    mask="99999-999"
    {...props}
  />
);

export default CPFInput;
